export default "__VITE_ASSET__CF3SS54U__"